module.exports = __webpack_public_path__ + "img/Giving-Gamers-Black.3897473d.png";